var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFE2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 18.6667C24.6527 18.6667 18.666 24.6533 18.666 32C18.666 39.3467 24.6527 45.3333 31.9993 45.3333C39.346 45.3333 45.3327 39.3467 45.3327 32C45.3327 24.6533 39.346 18.6667 31.9993 18.6667ZM36.4793 35.0667C36.866 35.4533 36.866 36.0933 36.4793 36.48C36.2793 36.68 36.026 36.7733 35.7727 36.7733C35.5194 36.7733 35.266 36.68 35.066 36.48L31.9993 33.4133L28.9327 36.48C28.7327 36.68 28.4793 36.7733 28.226 36.7733C27.9727 36.7733 27.7193 36.68 27.5194 36.48C27.1327 36.0933 27.1327 35.4533 27.5194 35.0667L30.586 32L27.5194 28.9333C27.1327 28.5467 27.1327 27.9067 27.5194 27.52C27.906 27.1333 28.546 27.1333 28.9327 27.52L31.9993 30.5867L35.066 27.52C35.4527 27.1333 36.0927 27.1333 36.4793 27.52C36.866 27.9067 36.866 28.5467 36.4793 28.9333L33.4127 32L36.4793 35.0667Z",
    fill: "#E7000B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoicon);
export default __webpack_public_path__ + "static/media/noicon.e56b7bdd4c2f6807abc8b1d540781fbe.svg";
export { ForwardRef as ReactComponent };